import React, { useState } from 'react';
import { IconInformation } from '../icon/information';
import './disclaimer.css';

interface IDisclaimerProps {
  element: JSX.Element | string;
  cy: string;
  widthIcon?: string;
  heightIcon?: string;
  position?: 'top' | 'bottom' | 'right' | 'left';
  colorIcon?: string;
}

export const Disclaimer = ({
  element,
  cy,
  widthIcon,
  heightIcon,
  position = 'right',
  colorIcon,
}: IDisclaimerProps) => {
  const [tooltipDisplay, setTooltipDisplay] = useState<boolean>(false);

  const handlePosition = (location: string) => {
    if (location === 'right') {
      return {
        left: '30px',
        top: '-18px',
      };
    }
    if (location === 'bottom') {
      return {
        right: '-50px',
        top: '25px',
      };
    }
    if (location === 'top') {
      return {
        bottom: '25px',
      };
    }
  };
  return (
    <div
      onMouseOver={() => {
        setTooltipDisplay(true);
      }}
      onMouseLeave={() => {
        setTooltipDisplay(false);
      }}
      className="disclaimer-container"
    >
      <IconInformation
        cy={cy}
        width={widthIcon}
        height={heightIcon}
        fill={colorIcon}
      />
      {tooltipDisplay && (
        <div className="tooltip-container" style={handlePosition(position)}>
          {element}
        </div>
      )}
    </div>
  );
};
